export default {
  AI_PREFILL_DOCUMENT: 'Renseigner par l’IA',
  IDENTITY_SETTINGS: {
    BUTTON: 'Pièces d’identité par site',
    TITLE: 'Pièces d’identité obligatoires',
    DESCRIPTION: 'Activez l’interrupteur pour rendre l’étape « Tes documents d’identité » obligatoire sur un site. Elle est désactivée par défaut. Chaque modification est enregistrée immédiatement.',
    POINTS_EXPLANATION: 'Quand cette étape est désactivée, ses 35 points sont transférés à « Ce qui compte pour toi », qui vaut alors 60 points. Le total du parcours reste de 130 points.',
    REQUIRED: 'Activé : étape obligatoire',
    DISABLED: 'Désactivé : étape non requise (par défaut)',
    SWITCH_LABEL: 'Pièces d’identité obligatoires pour {{site}}',
    UNNAMED_SITE: 'Site {{id}} (sans nom)',
    EMPTY: 'Aucun site disponible.',
    LOAD_ERROR: 'Impossible de charger les paramètres des sites. Réessayez.',
    SAVE_ERROR: 'La modification n’a pas pu être enregistrée. La valeur précédente a été rétablie. Réessayez avec l’interrupteur.',
    RETRY: 'Réessayer',
  },
  ACTION_MENU: {
    ADD: 'Ajouter au parcours',
    TITLE: 'Enrichir le parcours',
    HINT: 'Choisissez une action pour accompagner le collaborateur.',
    BUDDY: 'Buddy',
    BUDDY_DESCRIPTION: 'Désigner un référent',
    TRAINING: 'Formation',
    TRAINING_DESCRIPTION: 'Assigner une formation',
    WELCOME: 'Accueil',
    WELCOME_DESCRIPTION: 'Organiser son accueil',
    TASK: 'Tâche ou document',
    TASK_DESCRIPTION: 'Préparer une action à réaliser',
    SURVEY: 'Enquête',
    SURVEY_DESCRIPTION: 'Recueillir ses réponses',
    DEBRIEF: 'Débriefing',
    DEBRIEF_DESCRIPTION: 'Prévoir un point de suivi',
    APPOINTMENT: 'Rendez-vous',
    APPOINTMENT_DESCRIPTION: 'Planifier une rencontre',
    VIDEO: "Vidéo d'accueil",
    VIDEO_DESCRIPTION: 'Partager une vidéo de bienvenue',
    SIGNATURE: 'Signature électronique',
    SIGNATURE_DESCRIPTION: 'Faire signer un document',
    QUIZ: 'Quiz',
    QUIZ_DESCRIPTION: 'Évaluer les connaissances',
  },
  // Keep employee journey copy alongside the existing onboarding vocabulary.
  JOURNEY: {
    UNNAMED_TASK: 'Action sans intitulé',
    IDENTITY_TYPE_NOTE:
      'Plusieurs numéros d’identité sont enregistrés. L’API ne conserve pas le choix du type : celui-ci est déduit des numéros existants au chargement, sans les effacer.',
    TITLE: 'Mon onboarding',
    PROGRESS: 'du parcours',
    POINTS: 'points collectés',
    PTS: 'pts',
    PTS_SHORT: 'pts',
    JOUR_J: 'Jour J',
    JOUR_J_IN: 'J-{{days}}',
    WELCOME: 'Ton aventure commence ici. Avançons ensemble, une étape à la fois.',
    QUOTE: 'Chaque petit pas prépare une belle rencontre.',
    STEP_0: 'Faisons connaissance',
    STEP_1: 'Ce qui compte pour toi',
    STEP_2: 'Tes documents d’identité',
    STEP_3: 'Place aux signatures',
    STEP_4: 'Prêt pour l’aventure',
    DESC_0: 'Ta fiche personnelle, pour bien commencer.',
    DESC_1: 'Ta situation familiale et ton contact d’urgence.',
    DESC_2: 'Un dossier complet pour préparer ton arrivée.',
    DESC_3: 'Retrouve les documents à signer.',
    DESC_4: 'Formations, lectures et dernières actions.',
    BADGES: 'Tes badges',
    BADGE_0: 'Premier pas',
    BADGE_1: 'Bien entouré',
    BADGE_2: 'En règle',
    BADGE_3: 'Signé !',
    BADGE_4: 'Prêt !',
    BADGE_5: 'Bienvenue',
    EMYE: 'À tes côtés, pas à pas',
    EMYE_0: 'Commençons par toi. Vérifie tes coordonnées pour que ton équipe puisse préparer ton arrivée.',
    EMYE_1: 'Ces informations permettent de mieux t’accompagner. Aucun enfant ? La valeur zéro est bien acceptée.',
    EMYE_2: 'Prépare un document lisible, recto et verso. Tes pièces sont enregistrées avec ton dossier personnel.',
    EMYE_3:
      'Prends le temps de lire chaque document avant de le signer. Ton avancement sera confirmé après la signature.',
    EMYE_4: 'Dernière ligne droite : retrouve ici toutes tes actions, sans oublier les formations et les lectures.',
    EMYE_5: 'Ton parcours est terminé. Toute l’équipe te souhaite la bienvenue !',
    LOADING: 'Chargement de ton parcours…',
    LOAD_ERROR: 'Impossible de charger le parcours. Actualise la page pour réessayer.',
    SAVE: 'Enregistrer et continuer',
    SAVING: 'Enregistrement…',
    SAVE_ERROR:
      'L’enregistrement n’a pas pu être confirmé. Tes saisies sont conservées ici : vérifie ta connexion et réessaie.',
    NOT_PERSISTED:
      'La relecture du serveur ne confirme pas toutes les valeurs saisies. Vérifie les informations avant de continuer.',
    INVALID: 'Complète les champs requis et joins les documents manquants.',
    FIELD_INVALID: 'Vérifie ce champ requis et son format.',
    PRIVATE: 'Informations réservées à ton dossier RH',
    SELECT: 'Sélectionner',
    IDENTITY_NUMBER: 'Numéro du document',
    AVATAR: 'Ta photo de profil',
    AVATAR_NOTE: 'JPG ou PNG, 10 Mo max. La photo est enregistrée séparément dès sa sélection.',
    FILE_HINT: 'JPG, PNG ou PDF · 10 Mo max.',
    FILE_SAVED: 'Document enregistré',
    FILE_ERROR: 'Format non accepté ou fichier supérieur à 10 Mo.',
    UPLOADING: 'Envoi du fichier…',
    IDENTITY_LIMIT:
      'Certains types d’identité ne sont pas enregistrables par l’API actuelle. Seuls les types pris en charge sont proposés.',
    SERVER_PROGRESS: 'L’avancement est confirmé par tes données enregistrées.',
    REFRESH: 'Actualiser',
    DONE: 'Terminé',
    PENDING: 'À réaliser',
    LOCKED: 'Verrouillé',
    VIEW: 'Consulter',
    READ: 'Lire le document',
    UPLOAD: 'Déposer un document',
    DOWNLOAD: 'Télécharger',
    COMMENT: 'Commentaire',
    INSTRUCTIONS: 'Consignes',
    SIGN: 'Signer',
    VIEW_SIGNED: 'Voir le document signé',
    CERTIFICATE: 'Voir le certificat',
    HISTORY: 'Documents associés',
    DATE: 'Date indiquée :',
    NO_TASKS: 'Aucune action assignée pour cette étape.',
    TASK_STATUS_LIMIT:
      'L’API actuelle ne fournit pas de confirmation fiable de réalisation pour cette action. Elle reste visible sans validation automatique.',
    ACTION_ERROR: 'L’action n’a pas pu être confirmée. Réessaie après avoir vérifié ta connexion.',
    BEFORE_DAY_ONE: 'Avant ton premier jour',
    JOINED: 'Tu as rejoint l’équipe',
    DATE_UNKNOWN: 'Ta date d’entrée n’est pas renseignée.',
    POSITION: 'Ton poste',
    CONTRACT: 'Contrat',
    MANAGER: 'Ton manager',
    UNAVAILABLE: 'Non communiqué',
    MANAGER_UNKNOWN: 'Le manager n’est pas communiqué dans les données disponibles.',
    TEAM_LOCK: 'Ton équipe se dévoile à 50 % du parcours.',
    BUDDY_LOCK: 'Termine ton parcours pour découvrir ton buddy.',
    BUDDY_WELCOME:
      'Bienvenue dans l’équipe ! En l’absence de buddy, ton manager reste ton point de repère s’il est renseigné.',
    MESSAGE: 'Envoyer un message',
    RAIL_ERROR: 'Certaines informations de ton équipe ou de tes rendez-vous n’ont pas pu être chargées.',
    FINISHED: 'Ton onboarding est terminé. Bienvenue dans l’équipe !',
    FIELDS: {
      nom: 'Nom',
      prenom: 'Prénom',
      email_personelle: 'E-mail personnel',
      telephone: 'Téléphone personnel',
      adresse_user: 'Adresse',
      pays_user: 'Pays (code à 2 lettres)',
      ville_user: 'Ville',
      departement_naissance: 'Département de naissance',
      date_naissance: 'Date de naissance',
      num_securite_social: 'Numéro de sécurité sociale',
      situation_familiale: 'Situation familiale',
      num_enfants: 'Nombre d’enfants',
      user_contact_urgence: 'Nom du contact d’urgence',
      phone_user_urgence: 'Téléphone du contact d’urgence',
      identite_recto: 'Pièce d’identité · recto',
      identite_verso: 'Pièce d’identité · verso',
    },
  },
  UPLOADED: 'Uploadé',
  NOT_UPLOADED: 'Non uploadé',
  READ: 'Lu',
  NOT_READ: 'Non lu',
  lien: {
    list: {
      title: 'List des liens entre entités',
      btn_link_team: 'Ajouter lien entre équipes',
      btn_link_service: 'Ajouter lien entre services',
      equipe: 'Équipes',
      service: 'Services',
      tous: 'Tous',
      type: 'Type',
      entite: 'Entité',
      organigrame: 'Organigramme',
      Representant: 'Représentant',
      nimorte: "N'importe",
      Ambassadeur: 'Ambassadeur',
      Responsable: 'Responsable',
      Buddy: 'Buddy',
      ServiceLie: 'Service lié',
      EquipeLie: 'Equipe lié',
    },
    equipe: {
      title: 'Ajouter lien équipe',
      title1: 'lien équipe',
      equipe: 'Sélectionner équipe',
      nameEquipe: "Nom d'équipe",
      representant: 'Sélectionner les représentants',
      nameRep: 'Les représentants',
      existe: 'Le lien existe déjà',
    },
    service: {
      title: 'Ajouter lien service',
      title1: 'lien service',
      equipe: 'Sélectionner service',
      nameEquipe: 'Nom de service',
      representant: 'Sélectionner les représentants',
      nameRep: 'Les représentants',
    },
    DELETE: {
      TITLE: '  Supprimer lien',
      DESC_1: ' suppression lien ...',
      DESC_2: 'Êtes-vous sûr de supprimer définitivement ce lien?',
      BTN_DELETE: 'Supprimer',
      BTN_CANCEL: 'Annuler',
    },
  },
  onboarding: {
    title: "Processus d'Onboarding",
    heure: 'temps',
    btn_add: 'Nouvelle règle',
    TYPE: 'TYPE',
    nom: 'nom',
    organigrame: 'Organigramme',
    Cible: 'Type cible',
    evenement: 'événement',
    Periorite: 'Priorité',
    Haut: 'Haut',
    Moyen: 'Moyen',
    Bas: 'Bas',
    STATUS_ACTIVE: 'Activé',
    STATUS_DEACTIVATE: 'Désactivé',
  },
  PARAMETERS: {
    FORM_TITLE: 'Paramétrer votre Onboarding',
    FORM_TOOLTIP: "Définissez le contact référent du site et le délai maximum d'application des règles d'onboarding.",
    DURATION_LABEL: "Durée en jours de l'onboarding",
  },
  newOnboarding: {
    title: 'Nouvelle règle',
    event: 'Événement',
    collab: "Avec qui l'organiser",
    periorite: 'Priorité de la règle',
    Cible: "Type d'entité d'accueil",
    Site: 'Site',
    Service: 'Service',
    Equipe: 'Équipe',
    acc: "Entité d'accueil",
    horaire: "Horaire de l'événement",
    ques1: "1) Sélectionnez l'entité d'accueil du nouveau collaborateur...",
    ques2: "2) Définissez le type d'évènement et avec qui l'organiser...",
    ques3: '3) Personnaliser la règle...',
    ques4: '2) Les détails du doccument',
  },
  DELETE: {
    TITLE: '  Supprimer onboarding',
    DESC_1: ' suppression onboarding ...',
    DESC_2: 'Êtes-vous sûr de supprimer définitivement ce regle?',
    BTN_DELETE: 'Supprimer',
    BTN_CANCEL: 'Annuler',
  },
}
